import React, { Component } from 'react';
import PropTypes from 'prop-types';
import RepatriationsTransactionsExecuteDialog from './RepatriationsTransactionsExecuteDialog';

class RepatriationsTransactionsExecute extends Component {
  render() {
    return (
      <div>
        <RepatriationsTransactionsExecuteDialog
          row={this.props}
          closeDialog={this.props.closeDialog}
          openDialog={this.props.openDialog}
          refreshTransactions={this.props.refreshTransactions}
          refreshHistories={this.props.refreshHistories}
        />
      </div>
    );
  }
}

RepatriationsTransactionsExecute.propTypes = {
  closeDialog: PropTypes.func.isRequired,
  openDialog: PropTypes.func.isRequired,
  refreshTransactions: PropTypes.func,
  refreshHistories: PropTypes.func,
};

export default RepatriationsTransactionsExecute;
